export const getCurrentUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch {
    return null;
  }
};

export const getToken = () => {
  return localStorage.getItem("token");
};

export const getUserPermissions = () => {
  const user = getCurrentUser();
  const level = user?.admin?.permissionLevel;
  const role = user?.role;

  return {
    isSuperAdmin: role === "super_admin" || level === 0,
    isAdmin: level === 1,
    isEditor: level === 2,
    isViewer: level === 3,
    isClient: level === 4,
    permissionLevel: level,
  };
};
